import SuperFetch from "../../../utils/superFetch"

export const getUserPaymentMethods = async () => {
    let response = await SuperFetch("/api/send/getPaymentMethods", "get")
    return response.data
}